<template>
  <div class="invitation_letter">
    <CCard title="Báo cáo tổng hợp văn bản" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
           <h4>Báo cáo tổng hợp văn bản</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
            <CCol sm="3"/>
            <CCol sm="2" class="mr-2">
                <label class='mb-0'>Từ ngày</label>
                <b-form-datepicker
                  id="datepicker"
                  class="mt-1"
                  v-model="inputFromDate"
                  locale="vi"
                  placeholder="Chọn ngày"
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                  :hide-header="true"
                  label-help=""
                  :value-as-date="true"
                  style="max-width: 150px; min-width: 135px;"
                ></b-form-datepicker>
            </CCol>
            <CCol sm="2" class="mr-1">
                <label class='mb-0'>Đến ngày</label>
                <b-form-datepicker
                  id="datepicker"
                  class="mt-1"
                  v-model="inputToDate"
                  locale="vi"
                  placeholder="Chọn ngày"
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                  :hide-header="true"
                  label-help=""
                  :value-as-date="true"
                  style="max-width: 150px; min-width: 135px"
                ></b-form-datepicker>
            </CCol>
            <CCol sm="2">
                <label class='mb-0'>&nbsp;</label>
                <vs-button style="min-width: 110px" warn square class="custom_btn_search"  @click="searchInvitationLetter()"><i class='bx bx-search'></i>&nbsp;Tìm kiếm</vs-button>
            </CCol>
            <CCol sm="3"/>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="data"
        compactMode
        :line-numbers="true"
        :sort-options="{
          enabled:false
        }"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có văn bản trong khoảng thời gian này
        </div>
        <template
          slot="table-row"
          slot-scope="props"
        >
          <div v-if="props.column.field === 'CONG_VAN'" class="row center">
            <vs-tooltip color="square">
                <vs-button transparent @click="displayFile(props.row.CONG_VAN)" :hidden="props.row.CONG_VAN.length <= 0"  square  circle icon><i class='bx bxs-file'></i></vs-button>
                <template #tooltip>
                    Xem file đính kèm
                </template>
            </vs-tooltip>
            
          </div>
          <div v-else-if="props.column.field === 'QTXL'" class="row center">
            <vs-tooltip color="success">
                <vs-button transparent @click="displayProcess(props.row.MA_CONG_VAN)"  success  circle icon><i class='bx bx-network-chart'></i></vs-button>
                <template #tooltip>
                    Quá trình xử lý
                </template>
            </vs-tooltip>
          </div>
          <div v-else-if="props.column.field === 'actions'" class="row center">
            <vs-tooltip color="success">
                <vs-button transparent @click="displayEmployees(props.row.SO_HIEU, props.row.TRICH_YEU, props.row.MA_CONG_VAN)"  success  circle icon><i class='bx bx-send'></i></vs-button>
                <template #tooltip>
                    Chỉ đạo nhanh
                </template>
            </vs-tooltip>
          </div>
        </template>
      </vue-good-table> 
    </CCard>
    <vs-dialog prevent-close width="650px" v-model="state.dialog.processed">
      <vue-good-table
        id="file"
        :columns="process_columns"
        :rows="process_data"
        :sort-options="{
          enabled:false
        }"
      >
      
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'">
            <CBadge v-if="props.row.TINH_TRANG == 2" color="success">{{props.row.TRANG_THAI}}</CBadge>
            <CBadge v-else color="danger">{{props.row.TRANG_THAI}}</CBadge>
          </div>

        </template>
      </vue-good-table>
    </vs-dialog>

    <vs-dialog prevent-close width="650px" v-model="state.dialog.detail">
      <vue-good-table
        id="file"
        :columns="file_columns"
        :rows="file_data"
        :sort-options="{
          enabled:false
        }"
      >
      
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'file_name'">
            <CLink
              @click="downloadFile(props.row.file_url)"
              target="_blank"
            >
                  {{props.row.file_name}}
            </CLink>
          </div>
          <div v-else-if="props.column.field === 'action'">
            <CButton
                v-c-tooltip="'Xem file đính kèm'"
                color="primary"
                @click="downloadFile(props.row.file_url)"
                variant="ghost"
                :transparent="true"
              >
                <i class='bx bx-download' ></i>
            </CButton>
          </div>

        </template>
      </vue-good-table>
    </vs-dialog>
    <vs-dialog prevent-close class="employee-dialog" width="650px" v-model="state.dialog.employee">
      <CCard  class="pb-0">
        <CCardHeader class="pt-0 pb-0">
            <h4>Chỉ đạo nhanh</h4>
        </CCardHeader>
        <CCardBody class="pt-2 pb-0">
              <vue-good-table
                @on-selected-rows-change="selectionChanged"
                :columns="employee_columns"
                :rows="employee_data"
                max-height="380px"
                :fixed-header="true"
                :sort-options="{
                  enabled:false
                }"
                :group-options="{
                  enabled: true,
                  headerPosition: 'top',
                  collapsable: true,
                }"
                :select-options="{
                  enabled: true,
                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                  selectionInfoClass: 'custom-class',
                  selectionText: 'người nhận',
                  clearSelectionText: 'xóa',
                  //disableSelectInfo: true, // disable the select info panel on top
                  selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
              >
              
                <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
                  Không có dữ liệu
                </div>
              </vue-good-table>
              <CRow class="py-2">
                <CCol sm="12">
                  <CTextarea
                    placeholder="Nhập nội dung tin nhắn"
                    height="500px"
                    :value.sync="content"
                    rows="2"
                  />
                </CCol>
              </CRow>
            <CRow class="py-2">
                <CCol v-if="this.AppActiveUser.send_sms === '1'" sm="12" class="center">
                    <vs-button square class="float-right" @click="sendNotification">
                      <i class='bx bx-message-square-detail'></i>&nbsp;Gửi thông báo
                    </vs-button>
                    
                    <vs-button success square class="float-right" @click="sendSmsMessage">
                      <i class='bx bx-send'></i>&nbsp;Gửi SMS
                    </vs-button>
                </CCol>
                <CCol v-else sm="12" class="center">
                    <vs-button square class="float-right" @click="sendNotification">
                      <i class='bx bx-message-square-detail'></i>&nbsp;Gửi chỉ đạo
                    </vs-button>
                </CCol>
              </CRow>
        </CCardBody>
      </CCard>
      
    </vs-dialog>
  </div>
</template>

<script>
  import moment from "moment";
  import { mapState, mapActions } from "vuex";
  import ClientFactory from "@/api/ClientFactory";
  import { VueGoodTable } from 'vue-good-table';
  const dropdownsApi = ClientFactory.get("dropdowns");
  const iOfficeApi = ClientFactory.get("ioffices");
  const pushNotificationsApi = ClientFactory.get("notifications");
  
  export default {
    components: {
        VueGoodTable
    },
    data(){
      return {
        content: "",
        inputFromDate: new Date(),
        inputToDate: new Date(),
        documentNo:"",
        trich_yeu: "",
        ma_cong_van: -1,
        data: [],
        file_columns:[
          {
            label: 'Tên tệp tin',
            field: 'file_name',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Tải tệp tin',
            field: 'action',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
        ],
        file_data:[],
        process_columns:[
          {
            label: 'Người nhận',
            field: 'NGUOI_NHAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Trạng thái',
            field: 'action',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
          {
            label: 'Ngày nhận',
            field: 'NGAY_DEN',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
          {
            label: 'Ngày xem/xử lý',
            field: 'NGAY_XEM',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
        ],
        process_data:[],
        employee_columns:[
          {
            label: 'Họ và tên',
            field: 'full_name',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Số điện thoại',
            field: 'phone_number',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td',
          }
        ],
        employee_data:[],
        rowEmployeeSelection:[],
        state: {
            dialog: {
                processed: false,
                detail: false,
                employee: false
            },
            is_open: true
        },
      };
    },
    async created() {
      var date = new Date();
      this.inputFromDate = new Date(Date.now() - 15 * 24 * 60 * 60 * 1000);
      this.inputToDate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
      this.getInvitationLetter();
    },
    methods: {
      ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
      getInvitationLetter: async function () {
        this.loading(this.$vs);
        this.data=[];
        let fromDate = moment(this.inputFromDate).format("DD/MM/YYYY");
        //let fromDate = '01/01/2021';
        let toDate = moment(this.inputToDate).format("DD/MM/YYYY");
        const { data } = await iOfficeApi.reportInvitationLetter(fromDate, toDate,2);
        //console.log(data);
        
        this.checkResponseData(data);
        this.closeLoading();
      },

      checkResponseData(data) {
      if(data.status == "success")
      { 
        this.data = data.data;
      }else{
        if(data.message != "Xin lỗi, không có dữ liệu")
          this.notify({
            error:true,
            title: "Thông báo",
            text: data.message
          });
      }
     },

      searchInvitationLetter(){
        this.getInvitationLetter();
      },
      async displayEmployees(documentNo, trich_yeu, ma_cong_van){
        this.loading(this.$vs);
        const { data } =await dropdownsApi.getiOfficeEmployeeByDepartment();
        if(data != null && data.data.length > 0) {
          this.employee_data = data.data[0].departments;
          this.documentNo = documentNo;
          this.trich_yeu = trich_yeu;
          this.ma_cong_van = ma_cong_van;
          this.state.dialog.employee = true;
        } else {
          this.notify({
              error: true,
              text: "Có lỗi xảy ra",
          });
        }
        
        this.closeLoading();
        
      },
      async displayProcess(ma_cong_van){
        console.log(ma_cong_van);
        this.loading(this.$vs);
        const { data } =await iOfficeApi.getProcessDocument(ma_cong_van);
        if(data != null && data.data.length > 0) {
          this.process_data = data.data;
        } else {
          this.process_data = [];
        }
        
        this.state.dialog.processed = true;
        this.closeLoading();
        
      },
      async sendSmsMessage(){
        if(this.rowEmployeeSelection.length ===0){
          return this.notify({
              error: true,
              text: "Vui lòng chọn người nhận",
          })
        }
        if(this.content.length ===0){
          return this.notify({
              error: true,
              text: "Vui lòng nhập nội dung tin nhắn",
          })
        }
        let phoneList = '';
        for (let index = 0; index < this.rowEmployeeSelection.length; index++) {
          const phone_number = this.rowEmployeeSelection[index].phone_number;
          phoneList += phone_number != null ? `${phone_number},` : '';
        }
        let noidung = `[DHNB][Giay moi: ${this.documentNo}][Nguoi gui: ${this.AppActiveUser.username}] ${this.content}`
        let data = await iOfficeApi.sendSms(phoneList,noidung);   
        
        this.notify({
              success: true,
              text: "Gửi tin nhắn thành công",
          });
        this.state.dialog.employee=false;
      },
      async sendNotification(){
        if(this.rowEmployeeSelection.length ===0){
          return this.notify({
              error: true,
              text: "Vui lòng chọn người nhận",
          })
        }
        if(this.content.length ===0){
          return this.notify({
              error: true,
              text: "Vui lòng nhập nội dung",
          })
        }
        this.loading(this.$vs);
        let userList = [];
        for (let index = 0; index < this.rowEmployeeSelection.length; index++) {
          const user_name = this.rowEmployeeSelection[index].user_name;
          userList.push(user_name);
        }
        let noidung = `${this.content}`
        let data = {
          title: `[DHNB][VB: ${this.documentNo}][${this.trich_yeu}]`,
          message: noidung,
          target_usernames: userList,
          feature: 'LETTER',
          ioffice: {
            ma_cong_van: this.ma_cong_van,
            nguoi_nhan: this.rowEmployeeSelection
          }
        }
        
        let response = await iOfficeApi.quickGuidance(data);
        console.log(response);   
        this.notify({
          success: true,
          text: "Gửi chỉ đạo thành công",
        });
        this.state.dialog.employee=false;
        this.closeLoading();
      },
      displayFile(files){
        //console.log(files);
        let arrFile = files.split(';');
        let data =[];

        for (let index = 0; index < arrFile.length; index++) {
          let fileName = arrFile[index];
          if(fileName.length>50)
          {
            let i = fileName.lastIndexOf('.');
            let fileEntension = fileName.substring(i,fileName.length);
            fileName = `${fileName.substring(0,45)}...${fileEntension}`;
          }
          fileName = fileName.replaceAll('_',' ');

          data[index]={
            file_name:fileName,
            file_url:arrFile[index]
          }
        }
        this.file_data = data;

        //show dialog
        this.state.dialog.detail = true;
        //this.displayFileModal = true;
      },
      async downloadFile(file_name){
        this.loading(this.$vs);
        //console.log(file_name);
        const { data } = await iOfficeApi.downloadFile(file_name);
        // console.log(data);
        var base64Data = data.data;
        var a = document.createElement("a"); //Create <a>
        a.href =  `data:application/pdf;base64,${base64Data}`
        a.download = file_name; //File name Here
        a.click(); //Downloaded file
        a.remove();
        this.closeLoading();
      },
      selectionChanged(params){
        this.rowEmployeeSelection = params.selectedRows;
      },
      CheckRole(id) {
        return this.AppActiveUser.role.includes(id);
      },
    },
    computed: {
      ...mapState("auth", ["AppActiveUser"]),
      columns() {
        const cols = [
          {
            label: 'Nội dung',
            field: 'TRICH_YEU',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Số ký hiệu',
            field: 'SO_HIEU',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
          {
            label: 'Đơn vị gửi',
            field: 'NOI_LUU',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '250px',
          },
          {
            label: 'Ngày gửi',
            field: 'date',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
          {
            label: 'Hạn xử lý',
            field: 'han_xu_ly',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
          {
            label: 'QTXL',
            field: 'QTXL',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '60px',
          },
          {
            label: 'Đính kèm',
            field: 'CONG_VAN',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '90px',
          },
        ]
        if(this.CheckRole(13)) {
          cols.push({
            label: 'Thao tác',
            field: 'actions',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
            width: '90px',
          })
        }
        return cols;
      },
    },
    destroyed() {
      this.closeLoading();
    }
  };

</script>



<style lang="scss">
    .employee-dialog{
      padding-top:10px;
    }
    .invitation_letter{
      table.vgt-table td {
        vertical-align: inherit;
        color: black !important;
        font-size: 14.5px;
        //padding: 0.3rem !important;
        padding: 0em .75em .0em .75em;
      }
      .vgt-responsive {
        overflow-x: inherit;
      }
      .width-class{
        min-width: 3px !important;
      }
      .width-status{
        min-width: 10px !important;
      }
      .vs-checkbox-content{
        align-items: center;
        justify-content: center;
      }
    }
    
</style>